/**
 * AI media helpers
 * - Shopify-Original-Alt (data-media-alt) enthält "//AI" → "AI"-Label unten rechts
 * - Sichtbares alt-Attribut darf Product Title bleiben (wird nicht für die Erkennung gebraucht)
 * - Casual Download/Save von Bildern erschweren (kein harter Schutz)
 */
(function () {
  'use strict';

  var MARKER = /\/\/\s*AI\b/i;

  function cleanAlt(alt) {
    return String(alt || '')
      .replace(MARKER, '')
      .replace(/\s{2,}/g, ' ')
      .trim();
  }

  function aiSource(img) {
    if (!img) return '';
    var own = img.getAttribute('data-media-alt');
    if (own) return own;
    var host = img.closest('[data-media-alt]');
    if (host) return host.getAttribute('data-media-alt') || '';
    return img.getAttribute('alt') || '';
  }

  function ensureHost(img) {
    var picture = img.closest('picture');
    var target = picture || img;
    var parent = target.parentElement;
    if (!parent) return null;

    if (parent.classList.contains('ai-label-host')) return parent;

    var mediaKids = 0;
    for (var i = 0; i < parent.children.length; i++) {
      var tag = parent.children[i].tagName;
      if (tag === 'IMG' || tag === 'PICTURE' || tag === 'VIDEO') mediaKids++;
    }

    if (mediaKids <= 1) {
      parent.classList.add('ai-label-host');
      return parent;
    }

    var wrap = document.createElement('span');
    wrap.className = 'ai-label-host ai-label-host--wrapped';
    parent.insertBefore(wrap, target);
    wrap.appendChild(target);
    return wrap;
  }

  function attachAiLabel(img) {
    if (!img || img.nodeType !== 1 || img.tagName !== 'IMG') return;
    if (img.dataset.aiLabeled === '1') return;

    var source = aiSource(img);
    if (!MARKER.test(source)) return;

    img.dataset.aiLabeled = '1';

    // Sichtbares alt nur bereinigen, wenn der Marker dort wirklich steht
    var visibleAlt = img.getAttribute('alt') || '';
    if (MARKER.test(visibleAlt)) {
      img.setAttribute('alt', cleanAlt(visibleAlt));
    }

    var host = ensureHost(img);
    if (!host) return;
    var hasBadge = false;
    for (var bi = 0; bi < host.children.length; bi++) {
      if (host.children[bi].classList && host.children[bi].classList.contains('ai-label')) {
        hasBadge = true;
        break;
      }
    }
    if (hasBadge) return;

    var badge = document.createElement('span');
    badge.className = 'ai-label';
    badge.textContent = 'AI';
    badge.setAttribute('aria-hidden', 'true');
    host.appendChild(badge);
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    if (!scope.querySelectorAll) return;
    scope.querySelectorAll('img').forEach(function (img) {
      attachAiLabel(img);
    });
  }

  function hardenImage(img) {
    if (!img || img.dataset.aiProtected === '1') return;
    img.dataset.aiProtected = '1';
    img.setAttribute('draggable', 'false');
  }

  function protectAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    if (!scope.querySelectorAll) return;
    scope.querySelectorAll('img').forEach(hardenImage);
  }

  function onContextMenu(e) {
    var t = e.target;
    if (!t) return;
    if (t.closest && t.closest('img, picture, svg image, .ai-label-host')) {
      e.preventDefault();
    }
  }

  function onDragStart(e) {
    var t = e.target;
    if (!t) return;
    if (t.closest && t.closest('img, picture')) {
      e.preventDefault();
    }
  }

  function init() {
    scan(document);
    protectAll(document);

    document.addEventListener('contextmenu', onContextMenu, { capture: true });
    document.addEventListener('dragstart', onDragStart, { capture: true });

    if (typeof MutationObserver === 'undefined') return;
    var obs = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'attributes' && m.target && m.target.tagName === 'IMG') {
          attachAiLabel(m.target);
          hardenImage(m.target);
          continue;
        }
        if (!m.addedNodes) continue;
        for (var j = 0; j < m.addedNodes.length; j++) {
          var node = m.addedNodes[j];
          if (!node || node.nodeType !== 1) continue;
          if (node.tagName === 'IMG') {
            attachAiLabel(node);
            hardenImage(node);
          } else {
            scan(node);
            protectAll(node);
          }
        }
      }
    });
    obs.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['alt', 'src', 'data-media-alt']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
